import React from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../Hooks/useAuth";

const Login = () => {
  const { logInUsingEmail } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const destination = location.state?.from || "/";
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    if (data.pass1 !== data.pass2) {
      // setMessage("sorry, password didn't matched");
    } else {
      logInUsingEmail(data.email, data.pass1, navigate, destination);
    }
  };
  return (
    <div className="h-screen flex justify-center items-center">
      <div className="bg-gray-200 lg:w-1/2 text-black py-12 text-center">
        <h3>hello brp wassup?</h3>
        <form className="mx-5 space-y-6 mt-6" onSubmit={handleSubmit(onSubmit)}>
          <input
            className="w-full p-3 "
            {...register("email", { required: true })}
            placeholder="Enter your email"
          />
          {errors.exampleRequired && <span>This field is required</span>}
          <input
            className="w-full p-3"
            type="password"
            {...register("pass1", { required: true })}
            placeholder="Enter your pass"
          />
          {errors.exampleRequired && <span>This field is required</span>}
          <input
            className="w-full p-3"
            type="password"
            {...register("pass2", { required: true })}
            placeholder="Retype your password"
          />
          {errors.exampleRequired && <span>This field is required</span>}
          {/* <p className="font-bold text-red-600 uppercase">{message}</p> */}
          <input
            className=" px-5 py-2 text-gray-200"
            type="submit"
            value="Login"
          />
        </form>
      </div>
    </div>
  );
};

export default Login;
